import axios from 'axios'
import qs from 'qs'
import components from '~/lib/components'
import { DateTime } from 'luxon'
// import jQuery from 'jquery'

export default {
  data () {
    return {
      DateTime: DateTime,
      status: null,
      fuelTypes: [null, null, null, null],
      fuelPrices: [0, 0, 0, 0],
      prevStatuses: [0, 0, 0, 0],
      prevLitres: [0, 0, 0, 0],
      prevAmounts: [0, 0, 0, 0],
      prevFlagFilling: null,
      transactions: [],
      processedTransactions: [],
      audio: false,
      showAudioButton: false
    }
  },
  mixins: [components],
  computed: {
    reserve () {
      let amount = 100
      if (this.data && this.data.defaultAmount && parseInt(this.data.defaultAmount, 10)) {
        amount = parseInt(this.data.defaultAmount, 10)
      }
      return [amount, amount, amount, amount]
    },
    shouldPlayAlert () { // No longer used due to text-to-speech
      for (var i = 0; i < 4; i++) {
        if (this.status && this.status.pumpStatus && this.status.pumpStatus.pStat && this.status.pumpStatus.pStat[i] == '1') {
          return true
        }
      }
      return false
    },
    pumpStatusStr () {
      if (this.status && this.status.pumpStatus && this.status.pumpStatus.pStat) {
        return this.status.pumpStatus.pStat.join(',')
      }
      return ''
    },
    data () {
      return (this.component && this.component.data !== '' ? JSON.parse(this.component.data) : false)
    },
    total () {
      let ret = [0, 0, 0, 0]
      let num = this.$filters.num
      if (!this.status) {
        return ret
      }
      for (var i = 0; i < 4; i++) {
        if (this.status.pumpStatus.amount[i]) {
          ret[i] = num(this.status.pumpStatus.amount[i] / 100)
        } else {
          ret[i] = num((this.status.pumpStatus.litre[i] / 100) * (this.status.pumpStatus.prices[i].price[this.status.pumpStatus.cNozzle[i]] / 1000))
        }
      }
      return ret
    }
  },
  methods: {
    audioButtonClicked () {
      this.audio = document.querySelector('audio#gasNotifier')
      this.audio.volume = 0
      this.audio.play()
      this.showAudioButton = false
      this.audio.pause()
    },
    isPumpVisible (pumpNumber) {
      if (this.data && this.data.disabledPumps && this.data.disabledPumps.length) {
        for (let i = 0; i < this.data.disabledPumps.length; i++) {
          let p = this.data.disabledPumps[i]
          if (parseInt(p) === parseInt(pumpNumber)) {
            return false
          }
        }
      }
      return true
    },
    getDisplayedIndex (index) {
      const i = index + 1
      if (this.data && this.data.customNumbers && this.data.customNumbers['P' + i]) {
        return this.data.customNumbers['P' + i]
      }
      return i
    },
    getStatusText (pumpStatus, pumpIndex) {
      let source = parseInt(this.getSource(parseInt(this.status.pumpStatus.flagFilling, 10), pumpIndex))
      switch (pumpStatus) {
        case 0:
          return this._('Available')
        case 1:
          if (!source) {
            return this._('AUTO')
          } else {
            return this._('Nozzle out')
          }
        case 3:
          if (!source) {
            return this._('AUTO')
          } else {
            return this._('Filling')
          }
        case 5:
          return this._('Approved')
        case 8:
          return this._('Error')
        case 9:
          return this._('Error')
        default:
          return this._('Unknown')
      }
    },
    getStartButtonClass (pumpIndex) {
      if (!this.status) {
        return 'btn-default disabled'
      }
      if (this.status.pumpStatus.pStat[pumpIndex] === 0 || this.status.pumpStatus.pStat[pumpIndex] === 1) {
        return 'btn-success'
      }
      return 'btn-default disabled'
    },
    getStopButtonClass (pumpIndex) {
      if (!this.status) {
        return 'btn-default disabled'
      }
      if (this.status.pumpStatus.pStat[pumpIndex] === 3) {
        return 'btn-danger'
      }
      return 'btn-default disabled'
    },
    startFilling (pumpIndex) {
      this.EventBus.$emit('startFilling', { pumpIndex: pumpIndex, reserve: this.reserve[pumpIndex] })
    },
    stopFilling (pumpIndex) {
      this.EventBus.$emit('stopFilling', { pumpIndex: pumpIndex })
    },
    requestGasPumpStatus () {
      this.EventBus.$emit('requestGasPumpStatus')
    },
    async addToReceipt (transaction) {
      let $this = this
      try {
        let data = {
          locale: this.locale,
          shopId: this.shopId,
          count: transaction.litres,
          vat: 25.5,
          price: transaction.price
        }
        let gasType = transaction.gasType.trim()
        if (this.data && this.data.fuelTypes && this.data.fuelTypes[gasType]) {
          let productData = await axios.get(this.baseDomain + this.shopId + '/products/' + this.data.fuelTypes[gasType] + '.json')
          data.product = productData.data
        } else {
          data.productName = transaction.gasType + ', ' + this._('Pump') + ' ' + (this.getDisplayedIndex(transaction.pumpIndex))
        }
        await this.$store.dispatch('addToBasket', data)
        $this.showAddedToBasketNotification()
        for (let i = 0; i < $this.transactions.length; i++) {
          if (transaction.date.getTime() === $this.transactions[i].date.getTime()) {
            let d = {
              id: transaction.id,
              status: 1
            }
            await axios.patch($this.baseDomain + $this.shopId + '/gas/' + transaction.id + '.json?client=' + this.clientid, d)
            $this.transactions.splice(i, 1)
            $this.loadProcessedTransactions()
            break
          }
        }
      } catch (err) {
        $this.showAddedToBasketError(err)
      }
    },
    async notify (text) {
      let ios = (/(ipod|iphone|ipad)/i).test(navigator.userAgent)
      if(!this.audio && !ios) {
        this.audio = document.querySelector('audio#gasNotifier')
      } else {
        if(ios && !this.audio) {
          return
        }
      }
      if(ios && this.showAudioButton) {
        return
      }
      let data = {
        text: text,
        lang: this._('en'),
        client: this.clientid
      }
      if(!ios) {
        let response = await axios.get(this.baseDomain + this.shopId + '/speak.mp3?' + qs.stringify(data), {
          responseType: 'blob'
        })
        const url = window.URL.createObjectURL(new Blob([response.data]))
        this.audio.src = url
      } else {
        this.audio.src = this.baseDomain + this.shopId + '/speak.mp3?' + qs.stringify(data)
      }
      this.audio.volume = 1
      try {
        this.audio.play()
      } catch(e) {
        this.showAudioButton = true
      }
      /*
      // Alternative, using POST. More clean, but reloads the MP3 with every request :(
      let response = await axios.post(this.baseDomain + this.shopId + '/speak.mp3?client=' + this.clientid, {
        text: text,
        lang: this._('en')
      }, {
        responseType: 'blob'
      })
      */
    },
    async loadTransactions () {
      let response = await axios.get(this.baseDomain + this.shopId + '/gas.json?client=' + this.clientid + '&iDisplayStart=0&iDisplayLength=100')
      this.transactions = []
      for (var i = 0; i < response.data.length; i++) {
        let t = response.data[i]
        t.date = new Date(t.date)
        this.transactions.push(t)
      }
    },
    async loadProcessedTransactions () {
      let response = await axios.get(this.baseDomain + this.shopId + '/gas.json?processed=1&client=' + this.clientid + '&iDisplayStart=0&iDisplayLength=100')
      this.processedTransactions = []
      for (var i = 0; i < response.data.length; i++) {
        let t = response.data[i]
        t.date = new Date(t.date)
        this.processedTransactions.push(t)
      }
    },
    getSource (flag, pumpIndex) {
      return flag & Math.pow(2, pumpIndex + 4) ? '1' : '0'
    },
    getFillingStatus (flag, pumpIndex) {
      return flag & Math.pow(2, pumpIndex) ? '1' : '0'
    }
  }
}
